import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

  // run the free-shipping updater when the drawer opens
  if (window.fspUpdate) {
    setTimeout(window.fspUpdate, 0);
  }

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
// --- Free shipping progress ---
const FREE_SHIPPING_THRESHOLD = 10000; // 100 NZD in cents

function fspFormatMoney(cents) {
  if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
    return Shopify.formatMoney(cents, Shopify.money_format || "${{amount}}");
  }
  return (cents / 100).toFixed(2);
}

async function fspUpdate() {
  const wrap = document.getElementById('free-shipping-progress');
  if (!wrap) return;

  try {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    const cart = await res.json();

    const total = cart.total_price || 0;
    const remaining = Math.max(FREE_SHIPPING_THRESHOLD - total, 0);
    const pct = Math.min(100, Math.round((total / FREE_SHIPPING_THRESHOLD) * 100));

    const textEl = wrap.querySelector('.fsp__text');
    const barEl = wrap.querySelector('.fsp__fill');

if (remaining > 0) {
  textEl.innerHTML = `You're <strong>$${(remaining / 100).toFixed(2)}</strong> away from <strong>free shipping</strong>`;
  wrap.classList.remove('fsp--reached');
} else {
  textEl.innerHTML = `You've unlocked <strong>free shipping</strong>`;
  wrap.classList.add('fsp--reached');
}

    if (barEl) barEl.style.width = pct + '%';
  } catch (e) {}
}

// add THIS line so other code can call it later
window.fspUpdate = fspUpdate;

document.addEventListener('DOMContentLoaded', fspUpdate);
['cart:updated', 'cart:change', 'shopify:section:load'].forEach(ev =>
  document.addEventListener(ev, fspUpdate)
);
